export const BasePaths = {
  MAIN: "/app",
};
export const PublicPaths = {
  HOME: "/",
  LOGIN: "/",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password/:id",
  REGISTER: "/create-account",
  REQUEST_DELETE_ACCOUNT: "/request-delete-account",
};

export const PrivatePaths = {
  DASHBOARD: "/app/dashboard",
};

export const AdminPrivatePaths = {
  DASHBOARD: "/app/dashboard",
};
